/** ID de ruta interna para abrir una canción embebida en una tarea del profesor. */
export const TASK_SONG_ROUTE_ID = "__bordona_task__";

export const TASK_SONG_SESSION_KEY = "bordona-task-song-payload";

export type TaskSongSessionPayload = {
  taskId: string;
  teacherId: string;
  title: string;
  musicXml: string;
  youtubeUrl?: string;
  tempo?: number;
  classroomId?: string;
};

export function saveTaskSongSession(payload: TaskSongSessionPayload): void {
  sessionStorage.setItem(TASK_SONG_SESSION_KEY, JSON.stringify(payload));
}

export function loadTaskSongSession(): TaskSongSessionPayload | null {
  try {
    const raw = sessionStorage.getItem(TASK_SONG_SESSION_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as TaskSongSessionPayload;
  } catch {
    return null;
  }
}

export function clearTaskSongSession(): void {
  sessionStorage.removeItem(TASK_SONG_SESSION_KEY);
}
